import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e660e202&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e660e202",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-servicesplatform-fe/treasurenet-tnservices-servicesplatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e660e202')) {
      api.createRecord('e660e202', component.options)
    } else {
      api.reload('e660e202', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=e660e202&scoped=true", function () {
      api.rerender('e660e202', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ustnFinance/lending/index.vue"
export default component.exports